import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import { isNil } from 'lodash';
import * as atlasOps from '../../../api/Atlas/atlas-operations';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';
import Loading from '../../components/Loading';
import MapContainerAIAtlas from '../../containers/MapContainerAIAtlas';

import {
  GridContainer,
  Grid,
  GridLeftChild,
  GridRightChild,
  GridTopRightChild,
  GridBottomRightChild
} from './styles';

import DatasetStepOne from '../../components/DatasetStepOne';
import DatasetStepTwo from '../../components/DatasetStepTwo';

class CreateDataset extends Component {
  tableElement = React.createRef();

  state = {
    aiInterestArea: {}
  };

  setAIInterestArea = newAIInterestArea => {
    this.setState({ aiInterestArea: newAIInterestArea });
  };

  render() {
    const {
      atlas,
      deployEnv,
      gridBackgroundColor,
      isPreview,
      isPublic,
      loading,
      gmsConnection,
      gmsConnection2
    } = this.props;
    const { aiInterestArea } = this.state;
    if (loading) return <Loading />;
    return (
      <>
        <GridContainer backgroundcolor={gridBackgroundColor} fullScreen>
          <Grid>
            <GridLeftChild xs={12} md={8}>
              <MapContainerAIAtlas
                aiInterestArea={aiInterestArea}
                atlas={atlas}
                deployEnv={deployEnv}
                setAIInterestArea={this.setAIInterestArea}
              />
            </GridLeftChild>
            <GridRightChild xs={12} md={4}>
              <GridTopRightChild height="50%">
                <DatasetStepOne
                  aiInterestArea={aiInterestArea}
                  atlas={atlas}
                  isPreview={isPreview}
                  isPublic={isPublic}
                  gmsConnection={gmsConnection}
                />
              </GridTopRightChild>
              <GridBottomRightChild height="50%">
                <DatasetStepTwo
                  aiInterestArea={aiInterestArea}
                  atlas={atlas}
                  isPreview={isPreview}
                  isPublic={isPublic}
                  gmsConnection={gmsConnection}
                  gmsConnection2={gmsConnection2}
                />
              </GridBottomRightChild>
            </GridRightChild>
          </Grid>
        </GridContainer>
      </>
    );
  }
}

CreateDataset.defaultProps = {
  atlas: {},
  deployEnv: '',
  gmsConnection: {},
  gmsConnection2: {},
  gridBackgroundColor: '#98c1de',
  isPreview: false,
  isPublic: false
};

CreateDataset.propTypes = {
  atlas: PropTypes.object,
  deployEnv: PropTypes.string,
  gmsConnection: PropTypes.object,
  gmsConnection2: PropTypes.object,
  gridBackgroundColor: PropTypes.string,
  isPreview: PropTypes.bool,
  isPublic: PropTypes.bool,
  loading: PropTypes.bool.isRequired
};

export default withTracker(({ atlas }) => {
  let gmsConnectionId = '';
  let gmsConnection2Id = '';
  let subscription = {};
  let subscription2 = {};
  if (!isNil(atlas)) {
    gmsConnectionId = atlasOps.getGMSConnection(atlas);
    gmsConnection2Id = atlasOps.getGMSConnection2(atlas);
    subscription = Meteor.subscribe('gmsConnections.public', gmsConnectionId);
    subscription2 = Meteor.subscribe('gmsConnections.public', gmsConnection2Id);
  }
  return {
    loading: !isNil(atlas) && !subscription.ready() && !subscription2.ready(),
    gmsConnection: TelemetryConnections.findOne(gmsConnectionId),
    gmsConnection2: TelemetryConnections.findOne(gmsConnection2Id)
  };
})(CreateDataset);
